import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-generic-message',
    templateUrl: './generic-message.component.html',
    styleUrls: ['./generic-message.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class GenericMessageComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<GenericMessageComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);
  messages!: string[];

  ngOnInit(): void {
    this.messages = this.data.messages;
  }

  close(): void {
    this.dialogRef.close();
  }

}
